export const NONE_VALUE = "__NONE__";
export const NO_STATUS_VALUE = NONE_VALUE;
